module.exports = __webpack_public_path__ + "img/arrow-single.e804630c.png";